//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SingleMobileTable from '~/components/landing/single_mobile_table'
export default {
  name: 'SingleCoin',
  components: { SingleMobileTable },
  props: {
    wantedCoinsList: {
      type: Array,
      default: null
    },
    currencyType: {
      type: String,
      default: null
    }
  }
}
